import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import Lib from '../../../commons/lib';
import PosterList from './PosterList';
import EloadasFilter from './EloadasFilter';
import TimeFormatter from '../../../commons/TimeFormatter';
import QueryEmptyState from '../../../commons/queryempty';

class EloadasContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      angolNyelv: false,

      // ['LOAD', 'DATA', 'NETW', 'TABL', 'QUERY']
      tableStatus: 'QUERY',
      // ['LOAD', 'DATA', 'NETW']
      viewStatus: 'DATA',
      
      // DATA
      baseJson: [],
      viewObj: {},
      currentId: undefined,
      torlesId: undefined,
      showFilter: false,
      filters: {},
      
      // MODAL UTILS
      modalView: false,
      modalDelete: false,
      deleteButtonLoading: false,
      isTable: true,

      statusz: [],
    };
  }

  componentDidMount() {
    //this.listEloadas(this.state.filters);
    this.setState({showFilter: true});
    this.initForm();
  }

  initForm = () => {
    Services.initEloadasForm((err, res) => {
      if (!err) {
        this.setState({
          statusz: res[0].statusz,
          angolNyelv: res[0].angolnyelv
        });
      }
    });
  }

  hasRole = (roles, checkKarb) => {
    return this.props.globals.hasRole(roles, checkKarb);
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  handleTableLayoutChange = () => {
    this.setState(prevState => ({ isTable: !prevState.isTable }), () => this.listEloadas(this.state.filters));
  }

  listEloadas = (defaultFilters = {allapot: {name: 'AKTIV'}}) => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      const args = {...{image: !this.state.isTable}, ...this.state.filters};
      Services.listEloadas(args || defaultFilters, (err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  handleNewClick = () => {
    this.setState({
    }, () => {
      this.props.globals.route.navigate(this.props.globals.public_url + '/admin/esemenyek/eloadasok/felvitel');
    });
  }

  handleEditClick = (id) => {
    this.setState({
    }, () => {
      this.props.globals.route.navigate({
        pathname: this.props.globals.public_url + '/admin/esemenyek/eloadasok/modositas', 
        search: '?id=' + id
      });
    });
  }

  handleDeleteClick = (id) => {
    this.setState({
      torlesId: id
    }, () => {
      this.toggleDeleteModal();
    });
  }

  viewEloadas = (id) => {
    this.setState({
      viewStatus: 'LOAD',
    }, () => {
      Services.viewEloadas(id, (err, res) => {
        if (!err) {
          this.setState({
            viewObj: res[0],
            viewStatus: 'DATA',
          });
        } else {
          this.setState({
            viewStatus: 'NETW'
          });
        }
      });
    });
  }

  deleteEloadas = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteEloadas(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listEloadas(this.state.filters);
        this.props.globals.addSuccess('Előadás törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }
  
  handleViewClick = (id) => {
    this.setState({
      formStatus: 'LOAD',
      currentId: id,
    }, () => {
      this.viewEloadas(id, false);
      this.toggleViewModal();
    });
  }

  statusFormatter = (cell) => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment> 
          <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekint'} onClick={() => this.handleViewClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'megtekint'} delay={50}>
            {'Megtekintés'}
          </UncontrolledTooltip>
        </React.Fragment> 
        {this.hasRole(['ELOADAS_ELOADAS'], true) && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
              {'Módosítás'}
            </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'delete'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'delete'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )
      }
      </div>
    );
  }

  renderView = () => {
    const {
      viewObj
    } = this.state;

    return (
      <div>
        <h6>Előadás:</h6>
        <b>Azonosító: </b>
        {viewObj && viewObj.azonosito}
        <br />
        <b>Eredeti cím: </b>
        {viewObj && viewObj.eredeti}
        <br />
        <b>Cím: </b>
        {viewObj && viewObj.cim}
        <br />
        <b>Megjelenés éve: </b>
        {viewObj && viewObj.megjeleneseve}
        <br />
        <b>Bemutató: </b>
        {viewObj && TimeFormatter.formatDateTime(viewObj.bemutato)}
        <br />
        <b>Rendező: </b>
        {viewObj && viewObj.rendezo}
        <br />
        <b>Szereplők: </b>
        {viewObj && viewObj.szereplok}
        <br />
        <b>Leírás: </b>
        {viewObj && viewObj.leiras}
        <br />
        {this.state.angolNyelv == true ? 
          <div>
            <b>Leírás (angol): </b>
            {viewObj && viewObj.leirasangol}
          </div>
          : <div />
        }
        <br />
        <b>Előzetes: </b>
        {viewObj && viewObj.elozetes}
        <br />
        <b>Forrás: </b>
        {viewObj && viewObj.forras}
        <br />
        <b>Időtartam: </b>
        {viewObj && viewObj.idotartam && (viewObj.idotartam + ' perc')}
        <br />
        <b>Műfaj: </b>
        {viewObj && viewObj.mufajok && viewObj.mufajok}
        <br />
        <b>Korhatár besorolás: </b>
        {viewObj && viewObj.korhatar}
      </div>
    );
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: 'cim',
        text: 'Cím',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'eredeti',
        text: 'Eredeti cím',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'korhatarNev',
        text: 'Korhatár',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'idotartam',
        text: 'Időtartam',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
        formatter: (cell) => (cell ? cell + " perc" : "")
      },
      {
        dataField: 'bemutato',
        text: 'Bemutató dátuma',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
        formatter: (cell) => cell ? TimeFormatter.formatDateTime(cell) : "",
        filterValue: (cell) => cell ? TimeFormatter.formatDateTime(cell) : ""
      },
      {
        dataField: 'allapot.name',
        align: 'center',
        text: 'Státusz',
        style: {
          whiteSpace: 'pre-line'
        },
        formatter: this.statusFormatter
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatter
      }
    ];

    return (
      this.state.isTable ? (
        <div className="animated fadeIn">
          <BootstrapTable
            bootstrap4
            keyField="id"
            data={this.state.baseJson}
            columns={columns}
            filter={filterFactory()}
            pagination={paginationFactory(Lib.bootstraptableProps)}
            noDataIndication="Nincs megjelenítendő adat!"
          />
        </div>
      ) : (
        <div className="animated fadeIn">
          <PosterList 
            data={this.state.baseJson} 
            onViewClick={this.handleViewClick} 
            onEditClick={this.handleEditClick}
            onDeleteClick={this.handleDeleteClick}
          />
        </div>
      )
    );
  }

  renderTableView = () => {
    return(
      <div className="col-md-12">
        {{
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Vigyél fel új tételt!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => { this.listEloadas(this.state.filters); }}
          />),
          TABL: (this.renderTable()),
          QUERY: (<QueryEmptyState
            hasImage
          />)
        }[this.state.tableStatus]}
      </div>
    );
  }

  renderModals = () => {
    return(
      <React.Fragment>
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deleteEloadas()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalView} toggle={this.toggleViewModal} backdrop="static" size="lg">
        <ModalHeader>
          {'Megtekintés'}
        </ModalHeader>
        <ModalBody>
          {{
            LOAD: (<Loader />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => {}}
            />),
            DATA: (this.renderView())
          }[this.state.viewStatus]}
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>Vissza</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
    );
  }

  render = () => {
    const {
      isTable,
      showFilter,
    } = this.state;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-10">
            {showFilter && <EloadasFilter setFilter={filters => this.setState({filters: filters}, () => {this.listEloadas(filters); })} layoutClick={this.handleTableLayoutChange} isTable={isTable}/>}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.hasRole(['ELOADAS_ELOADAS'], true) && (
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
                {'Új előadás'}
              </Button>
            )}
          </div>
          {this.renderTableView()}
        </div>
        {this.renderModals()}
      </React.Fragment>
    );
  }
}

EloadasContent.propTypes = {
  globals: PropTypes.object
};

export default EloadasContent;
